<template>
  <container headTitle="Packages Dates and Pricing">
    <div slot="createbtn">
      <div class="row">
        <div class="col-12 d-flex justify-content-end">
          <div class="form-group m-0 search_package_btn">
            <input v-model="package_code" type="text" @keydown.enter.prevent="findPackage" class="form-control form-control-sm" placeholder="Code" />
            <button :disabled="package_code == '' || isPkgDatesLoading" @click.prevent="findPackage" class="btn btn-info btn-sm">Search</button>
          </div>
        </div>
      </div>
    </div>

    <div slot="content">
      <div class="container-fluid">
        <div v-if="!isPkgDatesLoading && pkgDatesDetails && pkgDatesDetails.options && pkgDatesDetails.options.length" class="row">
          <div class="col-12">
            <div class="card option_container">
              <div class="card-header p-2">
                Dates & Pricing :-
                <b
                  >{{ pkgDatesDetails.name }} <span style="color: #f56d6d; font-size: 12px">( {{ pkgDatesDetails.code }} )</span></b
                >
              </div>
              <div class="card-body p-2">
                <!-- Package Options Sections -->
                <div class="row">
                  <div class="col-10 col-md-10">
                    <div class="d-flex flex-wrap">
                      <div class="form-group mr-2 option_item" v-for="(option, index) in pkgDatesDetails.options" :key="option.name">
                        <label class="d-flex align-items-center mb-0">
                          <input v-model="active_option" :value="index" class="mr-2" type="radio" name="option_details" />
                          {{ option.name }}
                        </label>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="col-2 col-md-2 d-flex justify-content-end">
                  <button class="btn btn-info btn-sm" href="javascript:void(0)">
                    View Dates
                  </button>
                </div> -->
                </div>
              </div>
            </div>
            <div class="row mt-3 d-flex justify-content-center no-gutters">
              <div class="col-6">
                <div class="card position-sticky" style="top: 0">
                  <div class="card-header p-2 d-flex justify-content-between align-items-center">
                    <span>Packages Dates</span>
                    <div class="action_buttons">
                      <div @click.prevent="manageActionType('insert')" :class="{ active: date_types == 'insert' }" class="action_btn_item">Insert</div>
                      <div @click.prevent="manageActionType('update')" :class="{ active: date_types == 'update' }" class="action_btn_item">Update</div>
                      <div @click.prevent="manageActionType('disabled')" :class="{ active: date_types == 'disabled' }" class="action_btn_item">Disable</div>
                      <div @click.prevent="manageActionType('extends')" :class="{ active: date_types == 'extends' }" class="action_btn_item">Extends</div>
                      <div @click.prevent="manageActionType('currency')" :class="{ active: date_types == 'currency' }" class="action_btn_item">Currency</div>
                    </div>
                  </div>
                  <div class="card-body p-2">
                    <div class="dates_container">
                      <div class="dates_header">
                        <div @click.prevent="handleMonthChange('prev')" v-if="$moment(currentMonth).isBefore(currentDate, 'month')" class="prev_btn">
                          <a href="javascript:void()"> ‹ </a>
                        </div>
                        <div v-else></div>
                        <div class="month_info">
                          <label>
                            <input :checked="AllDatesSelected" v-if="hideSelectAllInput" @change.prevent="handleSelectAllDates" class="mr-2" type="checkbox" />
                            {{ currentDate.format("MMMM YYYY") }}
                          </label>
                        </div>
                        <div @click.prevent="handleMonthChange('next')" v-if="currentDate.isBefore($moment(currentMonth).add(11, 'month'))" class="next_btn">
                          <a href="javascript:void()"> › </a>
                        </div>
                        <div v-else></div>
                      </div>
                      <div class="dates_weeks">
                        <ul class="pkg-calendar-week">
                          <li v-for="(week, index) in weeks" :key="week">
                            <label class="d-flex align-items-center">
                              <input v-if="hideSelectAllInput" :checked="checkIfWeekSelected(index)" @change.prevent="handleWeekSelect(index, $event)" type="checkbox" class="mr-1" />
                              {{ week }}</label
                            >
                          </li>
                        </ul>
                        <ul class="pkg-calendar-days">
                          <li @click.prevent="handleSelectDates(item)" :class="[item.className]" v-for="item in calendarDates" :key="$moment(item.day).format('DDMMYYYY')">
                            <div class="d-flex justify-content-center align-items-center flex-column">
                              <span>{{ $moment(item.day).format("DD") }}</span>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div v-if="date_types != 'currency'" class="card" style="margin-left: 20px">
                  <div class="card-header p-2">Pricing Section</div>
                  <div class="card-body p-2 price-container">
                    <div class="row no-gutters">
                      <div class="col-6">
                        <div class="form-group mr-2">
                          <label for="adult_single_person" class="d-flex align-items-center">
                            <input
                              v-model="pricing.adult.singleallowed"
                              :disabled="['', 'disabled'].includes(date_types) || (['insert', 'extends'].includes(date_types) && is_honeymoon)"
                              type="checkbox"
                              name="adult_single_person"
                              id="adult_single_person"
                              class="mr-2"
                            />
                            Adult
                            <span>( pp with single )</span>
                          </label>
                          <input
                            v-model.trim.number="pricing.adult.single"
                            :disabled="!pricing.adult.singleallowed || !['insert', 'extends'].includes(date_types) || is_honeymoon"
                            v-input-type="'number'"
                            type="text"
                            class="form-control form-control-sm"
                          />
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="form-group">
                          <label class="d-flex align-items-center">Adult Surcharge</label>
                          <input
                            v-model.trim.number="pricing.adult.surcharge"
                            :disabled="['', 'disabled'].includes(date_types)"
                            v-input-type="'number'"
                            type="text"
                            class="form-control form-control-sm"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row no-gutters">
                      <div class="col-6">
                        <div class="form-group mr-2">
                          <label for="adult_twin_sharing" class="d-flex align-items-center"> Adult <span> ( pp on twin sharing )</span></label>
                          <input
                            v-model.trim.number="pricing.adult.twin"
                            :disabled="!pricing.adult.twinallowed || !['insert', 'extends'].includes(date_types)"
                            v-input-type="'number'"
                            type="text"
                            class="form-control form-control-sm"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row no-gutters">
                      <div class="col-6">
                        <div class="form-group mr-2">
                          <label for="adult_extra_bed" class="d-flex align-items-center"
                            ><input
                              v-model="pricing.adult.extrabedallowed"
                              :disabled="!['insert', 'extends'].includes(date_types) || is_honeymoon"
                              type="checkbox"
                              name="adult_extra_bed"
                              id="adult_extra_bed"
                              class="mr-2"
                            />
                            Adult <span>( pp With Extra Bed )</span></label
                          >
                          <input
                            v-model.trim.number="pricing.adult.extrabed"
                            :disabled="!pricing.adult.extrabedallowed || !['insert', 'extends'].includes(date_types) || is_honeymoon"
                            v-input-type="'number'"
                            type="text"
                            class="form-control form-control-sm"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row no-gutters">
                      <div class="col-6">
                        <div class="form-group mr-2">
                          <label for="child_with_bed" class="d-flex align-items-center"
                            ><input
                              v-model="pricing.child.cwballowed"
                              :disabled="['', 'disabled'].includes(date_types) || is_honeymoon"
                              type="checkbox"
                              name="child_with_bed"
                              id="child_with_bed"
                              class="mr-2"
                            />
                            CWB <span>( child with bed )</span> <span class="fnt-12 font-bold clr-red ml-2">( {{ pax_type_age("cwb") }} )</span></label
                          >
                          <input
                            v-model.trim.number="pricing.child.cwb"
                            :disabled="!pricing.child.cwballowed || !['insert', 'extends'].includes(date_types) || is_honeymoon"
                            v-input-type="'number'"
                            type="text"
                            class="form-control form-control-sm"
                          />
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="form-group">
                          <label class="d-flex align-items-center">CWB Surcharge</label>
                          <input
                            v-model.trim.number="pricing.child.cwbsurcharge"
                            :disabled="!pricing.child.cwballowed || ['', 'disabled'].includes(date_types) || is_honeymoon"
                            v-input-type="'number'"
                            type="text"
                            class="form-control form-control-sm"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row no-gutters">
                      <div class="col-6">
                        <div class="form-group mr-2">
                          <label for="child_with_no_bed" class="d-flex align-items-center"
                            ><input
                              v-model="pricing.child.cnballowed"
                              :disabled="['', 'disabled'].includes(date_types) || is_honeymoon"
                              type="checkbox"
                              name="child_with_no_bed"
                              id="child_with_no_bed"
                              class="mr-2"
                            />
                            CNB1 <span>( child with no bed )</span> <span class="fnt-12 font-bold clr-red ml-2">( {{ pax_type_age("cnb") }} )</span></label
                          >
                          <input
                            v-model.trim.number="pricing.child.cnb"
                            :disabled="!pricing.child.cnballowed || !['insert', 'extends'].includes(date_types) || is_honeymoon"
                            v-input-type="'number'"
                            type="text"
                            class="form-control form-control-sm"
                          />
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="form-group">
                          <label class="d-flex align-items-center">CNB1 Surcharge</label>
                          <input
                            v-model.trim.number="pricing.child.cnbsurcharge"
                            :disabled="!pricing.child.cnballowed || ['', 'disabled'].includes(date_types) || is_honeymoon"
                            v-input-type="'number'"
                            type="text"
                            class="form-control form-control-sm"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row no-gutters">
                      <div class="col-6">
                        <div class="form-group mr-2">
                          <label for="child_with_no_bed2" class="d-flex align-items-center"
                            ><input
                              v-model="pricing.child.cnb2allowed"
                              :disabled="['', 'disabled'].includes(date_types) || is_honeymoon"
                              type="checkbox"
                              name="child_with_no_bed2"
                              id="child_with_no_bed2"
                              class="mr-2"
                            />
                            CNB2 <span>( child with no bed )</span> <span class="fnt-12 font-bold clr-red ml-2">( {{ pax_type_age("cnb2") }} )</span></label
                          >
                          <input
                            v-model.trim.number="pricing.child.cnb2"
                            :disabled="!pricing.child.cnb2allowed || !['insert', 'extends'].includes(date_types) || is_honeymoon"
                            v-input-type="'number'"
                            type="text"
                            class="form-control form-control-sm"
                          />
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="form-group">
                          <label class="d-flex align-items-center">CNB2 Surcharge</label>
                          <input
                            v-model.trim.number="pricing.child.cnb2surcharge"
                            :disabled="!pricing.child.cnb2allowed || ['', 'disabled'].includes(date_types) || is_honeymoon"
                            v-input-type="'number'"
                            type="text"
                            class="form-control form-control-sm"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row no-gutters">
                      <div class="col-6">
                        <div class="form-group mr-2">
                          <label for="infant_pricing" class="d-flex align-items-center"
                            ><input
                              v-model="pricing.infantallowed"
                              :disabled="!['insert', 'extends'].includes(date_types) || is_honeymoon"
                              type="checkbox"
                              name="infant_pricing"
                              id="infant_pricing"
                              class="mr-2"
                            />
                            Infant
                          </label>
                          <input
                            v-model.trim.number="pricing.infant"
                            :disabled="!pricing.infantallowed || !['insert', 'extends'].includes(date_types) || is_honeymoon"
                            v-input-type="'number'"
                            type="text"
                            class="form-control form-control-sm"
                          />
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="form-group">
                          <label class="d-flex align-items-center">Surcharge Description</label>
                          <select :disabled="['', 'disabled'].includes(date_types)" v-model.trim="pricing['surcharge-description']" class="form-control form-control-sm">
                            <option value="">Choose</option>
                            <option value="Hotel">Hotel</option>
                            <option value="Flight">Flight</option>
                            <option value="Weekend">Weekend</option>
                            <option value="Long Weekend">Long Weekend</option>
                            <option value="Season">Season</option>
                            <option value="Peak Season">Peak Season</option>
                            <option value="Gala Dinner">Gala Dinner</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 d-flex justify-content-end">
                        <button v-if="date_types != ''" @click.prevent="submitFormData" :disabled="isSubmitting || $v.pricing.$invalid || isSubmitValid" class="btn btn-info btn-sm submit-btn mt-2">
                          <spinner v-if="isSubmitting" />
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="['', 'currency'].includes(date_types)" class="card" style="margin-left: 20px; margin-bottom: 15px" :style="{ 'margin-top': date_types != 'currency' ? '15px' : '' }">
                  <div class="card-header p-2">Currency Components</div>
                  <div class="card-body p-2">
                    <div class="row no-gutters">
                      <div class="col-md-3">
                        <div class="form-group mb-0 mr-2">
                          <label class="required">Rate Model</label>
                          <select :disabled="!['currency'].includes(date_types)" class="form-control form-control-sm" v-model="forex_pricing.price_model">
                            <option value="">Choose</option>
                            <option value="inr_only">INR Only</option>
                            <option value="fx_split">FX Split</option>
                            <option value="omit">Omit</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group mb-0 mr-2">
                          <label class="required">Source</label>
                          <input :disabled="!['currency'].includes(date_types)" type="text" class="form-control form-control-sm" v-model.trim="forex_pricing.benchmark.source" />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group mb-0 mr-2">
                          <label class="required">Currency</label>
                          <select :disabled="!['currency'].includes(date_types)" class="form-control form-control-sm" v-model.trim="forex_pricing.currency">
                            <option value="">Choose</option>
                            <option v-for="_currency in currency" :key="_currency.code" :value="_currency.code">{{ _currency.name }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group mb-0">
                          <label class="required">Rates</label>
                          <input
                            :disabled="!['currency'].includes(date_types)"
                            type="text"
                            class="form-control form-control-sm"
                            v-model.trim.number="forex_pricing.benchmark.rates"
                            v-input-type="'decimal'"
                            placeholder="Rates"
                          />
                        </div>
                      </div>
                    </div>

                    <table class="table mt-3">
                      <thead class="table-teal" style="top: 0">
                        <tr>
                          <th>Pax</th>
                          <th>Forex Amount</th>
                          <th>INR Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="_price in forex_pricing.pricing" :key="_price.type">
                          <td>
                            <div class="d-flex align-items-center">
                              <div class="pax" style="font-weight: 600">{{ _price.type }}</div>
                              <span class="fnt-12 font-bold clr-red ml-2" v-if="pax_type_age(_price.type)">( {{ pax_type_age(_price.type) }} )</span>
                            </div>
                          </td>
                          <td>
                            <div>
                              <input
                                :disabled="!['currency'].includes(date_types)"
                                type="text"
                                placeholder="FX Total"
                                v-model.trim.number="_price.fx"
                                v-input-type="'number'"
                                class="form-control form-control-sm"
                              />
                            </div>
                          </td>
                          <td>
                            <div>
                              <input
                                :disabled="!['currency'].includes(date_types)"
                                type="text"
                                placeholder="INR Amount"
                                v-model.trim.number="_price.amount"
                                v-input-type="'number'"
                                class="form-control form-control-sm"
                              />
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <hr class="my-2" />
                    <div class="currency-action-button">
                      <button
                        v-if="date_types != ''"
                        @click.prevent="submitFormData"
                        :disabled="isSubmitting || $v.forex_pricing.$invalid || isSubmitValid"
                        class="btn btn-info btn-sm submit-btn mt-2"
                      >
                        <spinner v-if="isSubmitting" />
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div v-if="!isPkgDatesLoading && !pkgDatesDetails" class="d-flex justify-content-center align-items-center clr-red" style="height: 300px">
              <h4 v-if="!pkgDatesDetails">No Package Found</h4>
              <h4 v-if="pkgDatesDetails && pkgDatesDetails.options && pkgDatesDetails.options.length == 0">No Options Found</h4>
            </div>
            <div v-if="isPkgDatesLoading" class="d-flex justify-content-center align-items-center clr-red" style="height: 300px">
              <spinner />
            </div>
          </div>
        </div>
      </div>
    </div>
  </container>
</template>

<script>
import methods from "./helpers/methods";
import computed from "./helpers/computed";
import { required } from "vuelidate/lib/validators";
export default {
  mixins: [methods, computed],
  name: "PackagesDates",
  data() {
    return {
      package_code: this?.$route?.query?.pkg_code || "",
      active_option: 0,
      currentDate: this.$moment(),
      currentMonth: this.$moment(),
      date_types: "",
      weeks: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      modifiedDates: [],
      selectedDates: [],
      extendsLastPrice: null,
      forex_pricing: {
        price_model: "",
        currency: "",
        benchmark: {
          source: "",
          captured_on: this.$moment().format("YYYY-MM-DD"),
          rates: ""
        },
        pricing: [
          { type: "Adult Single", key: "adult_single", fx: "", amount: "" },
          { type: "Adult Twin", key: "adult_twin", fx: "", amount: "" },
          { type: "Adult Triple", key: "adult_triple", fx: "", amount: "" },
          { type: "CWB", key: "child_cwb", fx: "", amount: "" },
          { type: "CNB1", key: "child_cnb", fx: "", amount: "" },
          { type: "CNB2", key: "child_cnb2", fx: "", amount: "" },
          { type: "Infant", key: "infant", fx: "", amount: "" }
        ]
      },
      pricing: {
        adult: {
          single: "",
          singleallowed: true,
          twin: "",
          twinallowed: true,
          extrabed: "",
          extrabedallowed: true,
          surcharge: ""
        },
        child: {
          cwballowed: true,
          cwb: "",
          cwbsurcharge: "",
          cnballowed: true,
          cnb: "",
          cnbsurcharge: "",
          cnb2allowed: true,
          cnb2: "",
          cnb2surcharge: ""
        },
        "surcharge-description": "",
        infant: "",
        infantallowed: true
      },
      isSubmitting: false
    };
  },
  watch: {
    date_types() {
      this.modifiedDates = [];
      this.pricing = JSON.parse(JSON.stringify(this.datesPricing));
      this.forex_pricing = JSON.parse(JSON.stringify(this.forexPricing));
      this.currentDate = this.$moment();
      this.currentMonth = this.$moment();
      if (["update", "disabled", "currency"].includes(this.date_types)) {
        this.modifiedDates = JSON.parse(JSON.stringify(this.selectedDates));
      } else if (this.date_types == "extends") {
        const _last_month = this.selectedDates[this.selectedDates.length - 1];
        const _last_pricing = _last_month.items[_last_month.items.length - 1];
        this.currentDate = this.$moment(_last_pricing.day).add(1, "days");
        this.currentMonth = this.$moment(_last_pricing.day).add(1, "days");
        this.pricing = _last_pricing?.prices ? JSON.parse(JSON.stringify(_last_pricing?.prices)) : this.pricing;
      }
    },
    active_option(value) {
      this.date_types = "";
      this.selectedDates = [];
      this.modifiedDates = [];
      this.pricing = JSON.parse(JSON.stringify(this.datesPricing));
      this.forex_pricing = JSON.parse(JSON.stringify(this.forexPricing));
      this.currentDate = this.$moment();
      this.currentMonth = this.$moment();
      const selectOption = this.pkgDatesDetails?.options[value];
      for (const dates of selectOption?.dates || {}) {
        const month = this.$moment(dates.month);
        for (const data of dates?.items) {
          const date = this.$moment(`${month.format("YYYY-MM")}-${data.value}`);
          this.bindDatesOnPageLoad({ ...data, day: date });
        }
      }
    },
    pkgDatesDetails: {
      deep: true,
      immediate: true,
      handler(value) {
        this.date_types = "";
        this.selectedDates = [];
        this.modifiedDates = [];
        if (value?.options?.length) {
          const selectOption = value?.options[this.active_option];
          for (const dates of selectOption?.dates || {}) {
            const month = this.$moment(dates.month);
            for (const data of dates?.items) {
              const date = this.$moment(`${month.format("YYYY-MM")}-${data.value}`);
              this.bindDatesOnPageLoad({ ...data, day: date });
            }
          }
        }
      }
    }
  },
  created() {
    if (this.package_code) {
      this.fetchPackageDatesPricing(this.package_code);
      this.getCurrency();
    }
  },
  computed: {
    renderDates() {
      if (this.date_types == "") {
        return this.selectedDates;
      }

      return this.modifiedDates;
    },
    AllDatesSelected() {
      let isChecked = true;
      for (const item in this.weeks) {
        if (!this.checkIfWeekSelected(item)) {
          isChecked = false;
          break;
        }
      }
      return isChecked;
    },
    hideSelectAllInput() {
      const _monthIndex = this.modifiedDates.findIndex((data) => data.month == this.currentDate.format("MM-YYYY"));
      if (this.date_types == "") {
        return false;
      }
      if (["insert", "extends"].includes(this.date_types)) {
        return true;
      }
      if (!["insert", "extends"].includes(this.date_types)) {
        return _monthIndex != -1;
      }
      return false;
    },
    isSubmitValid() {
      let checked = true;
      if (["insert", "extends"].includes(this.date_types)) {
        checked = this.modifiedDates.length == 0;
      }
      if (["update", "disabled", "currency"].includes(this.date_types)) {
        for (const month of this.modifiedDates) {
          for (const date of month.items) {
            if (date?.is_update) {
              checked = false;
              break;
            }
          }
        }
      }
      return checked;
    }
  },
  methods: {
    pax_type_age(key) {
      const _age = this.pkgDatesDetails.ageBands.find((val) => val.type.toLowerCase() == key.toLowerCase());
      return _age ? `${_age.ageFrom} - ${_age.ageTo}` : null;
    },
    findPackage() {
      this.$router.push({ name: "AvailableDates", query: { pkg_code: this.package_code } });
      this.fetchPackageDatesPricing(this.package_code);
    },
    handleWeekSelect(week, event) {
      if (this.date_types != "") {
        const _days = this.currentDate.daysInMonth();
        for (let _d = 1; _d <= _days; _d++) {
          const _monthIndex = this.modifiedDates.findIndex((data) => data.month == this.currentDate.format("MM-YYYY"));
          const date = this.$moment(`${this.currentDate.format("YYYY-MM")}-${_d <= 9 ? `0${_d}` : _d}`);
          if (this.$moment().isSame(date, "months") && this.$moment().isAfter(date, "days")) {
            continue;
          }
          if (date.format("d") == week) {
            const _matchDate = this.modifiedDates[_monthIndex]?.items.findIndex((_md) => this.$moment(_md.day).isSame(date, "days"));
            if (event.target.checked) {
              if (_monthIndex != -1) {
                if (_matchDate == -1) {
                  if (["insert", "extends"].includes(this.date_types)) this.modifiedDates[_monthIndex]?.items.push({ day: date, active: true, prices: { ...this.pricing } });
                } else {
                  let _upObj = { ...this.modifiedDates[_monthIndex]?.items[_matchDate], is_update: true };
                  if (this.date_types == "disabled") _upObj.active = false;
                  this.modifiedDates[_monthIndex].items.splice(_matchDate, 1, _upObj);
                }
              } else this.modifiedDates.push({ month: this.currentDate.format("MM-YYYY"), items: [{ day: date, active: true, prices: { ...this.pricing } }] });
            } else {
              if (_monthIndex != -1) {
                if (_matchDate != -1) {
                  if (["insert", "extends"].includes(this.date_types)) this.modifiedDates[_monthIndex]?.items.splice(_matchDate, 1);
                  if (["update", "currency"].includes(this.date_types))
                    this.modifiedDates[_monthIndex].items.splice(_matchDate, 1, { ...this.modifiedDates[_monthIndex]?.items[_matchDate], is_update: false });
                  if (this.date_types == "disabled")
                    this.modifiedDates[_monthIndex].items.splice(_matchDate, 1, { ...this.modifiedDates[_monthIndex]?.items[_matchDate], is_update: true, active: true });
                }
              }
            }
          }
        }
      }
    },
    checkIfWeekSelected(index) {
      const _days = this.currentDate.daysInMonth();
      let _weekCount = 0;
      let _monthWeekCount = 0;
      for (let _d = 1; _d <= _days; _d++) {
        const date = this.$moment(`${this.currentDate.format("YYYY-MM")}-${_d <= 9 ? `0${_d}` : _d}`);
        if (this.$moment().isSameOrBefore(date, "day") && date.format("d") == index) _weekCount++;
      }
      const _monthIndex = this.modifiedDates.findIndex((data) => data.month == this.currentDate.format("MM-YYYY"));
      if (_monthIndex != -1) {
        debugger;
        _monthWeekCount =
          this.modifiedDates[_monthIndex]?.items?.reduce((count, data) => {
            if (this.$moment().isSameOrBefore(this.$moment(data?.day), "day") && this.$moment(data?.day)?.format("d") == index) {
              if (["insert", "extends"].includes(this.date_types)) count++;
              if (this.date_types == "update") {
                if (data.is_update) count++;
              }
              if (this.date_types == "disabled") {
                if (!data.active) count++;
              }
            }
            return count;
          }, 0) || 0;
        return _weekCount == _monthWeekCount;
      }
    },

    handleSelectAllDates(evt) {
      for (const week in this.weeks) {
        this.handleWeekSelect(week, evt);
      }
    },
    submitFormData() {
      const formData = this.modifiedDates;
      this.updatePackageDatesPricing({
        _id: this?.pkgDatesDetails?._id,
        options_id: this.active_option,
        options_name: this.pkgDatesDetails?.options[this.active_option]?.name,
        data: formData,
        pricing: this.pricing,
        forex_pricing: this.forex_pricing,
        action_type: ["insert", "extends"].includes(this.date_types) ? "insert" : this.date_types
      }).then((data) => {
        if (data.status) {
          this.$toasted.clear();
          this.$toasted.success(data.message, { duration: 1500, position: "bottom-center" });
          if (["insert", "extends"].includes(this.date_types)) this.modifiedDates = [];

          this.pricing = JSON.parse(JSON.stringify(this.datesPricing));
          this.forex_pricing = JSON.parse(JSON.stringify(this.forexPricing));
          this.fetchPackageDatesPricing(this?.$route?.query?.pkg_code).then((data) => {
            this.modifiedDates = JSON.parse(JSON.stringify(this.selectedDates));
            this.date_types = "";
          });
        }
        if (!data.status) {
          this.$toasted.clear();
          this.$toasted.error(data.message, { duration: 1500, position: "bottom-center" });
        }
      });
    },

    manageActionType(type) {
      let _date_type = "";
      if (type == this.date_types) _date_type = "";
      else _date_type = type;
      this.date_types = _date_type;
    }
  },
  validations() {
    let pricing = { adult: {}, child: {} };
    if (["insert", "extends"].includes(this.date_types)) {
      for (const adult in this.pricing.adult) {
        if (!this.is_honeymoon && adult.includes("allowed") && this.pricing.adult[adult]) {
          const value = adult.replace("allowed", "");
          pricing = { ...pricing, adult: { ...pricing.adult, [value]: { required } } };
        } else pricing = { ...pricing, adult: { ...pricing.adult, twin: { required } } };
      }
      if (!this.is_honeymoon && this.pricing.child.cnballowed) pricing = { ...pricing, child: { ...pricing.child, cnb: { required } } };
      if (!this.is_honeymoon && this.pricing.child.cnb2allowed) pricing = { ...pricing, child: { ...pricing.child, cnb2: { required } } };
      if (!this.is_honeymoon && this.pricing.child.cwballowed) pricing = { ...pricing, child: { ...pricing.child, cwb: { required } } };
      if (!this.is_honeymoon && this.pricing.infantallowed) pricing = { ...pricing, infant: { required } };
    }

    if (this.date_types == "update") {
      if (!this.is_honeymoon && this.pricing.adult.singleallowed) pricing = { ...pricing, adult: { ...pricing.adult, surcharge: {} } };
      if (!this.is_honeymoon && this.pricing.child.cnballowed) pricing = { ...pricing, child: { ...pricing.child, cnbsurcharge: {} } };
      if (!this.is_honeymoon && this.pricing.child.cnb2allowed) pricing = { ...pricing, child: { ...pricing.child, cnb2surcharge: {} } };
      if (!this.is_honeymoon && this.pricing.child.cwballowed) pricing = { ...pricing, child: { ...pricing.child, cwbsurcharge: {} } };
    }

    let _forex_price = {
      price_model: { required },
      currency: { required },
      benchmark: {
        source: { required },
        rates: { required }
      }
    };

    return { pricing, forex_pricing: _forex_price };
  }
};
</script>

<style scoped>
.price-container {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.currency-action-button {
  display: flex;
  justify-content: flex-end;
}

.currency-action-button button {
  border-radius: 0;
  width: 80px;
  font-size: 14px;
  padding: 2px 10px;
}
.option_container .option_item label {
  cursor: pointer;
}

.dates_container .dates_header {
  display: flex;
  justify-content: space-between;
}

.dates_container .dates_header {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #17a2b8;
  padding-bottom: 5px;
}

.dates_container .dates_header .month_info {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 700;
  word-spacing: 4px;
  letter-spacing: 1px;
  color: #3c3c3c;
  user-select: none;
}

.dates_container .dates_header .month_info label {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.dates_container .dates_header .prev_btn,
.dates_container .dates_header .next_btn {
  background-color: #e5e5e5;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.dates_container .dates_header .prev_btn a,
.dates_container .dates_header .next_btn a {
  color: #8f8f8f;
  font-size: 32px;
  position: absolute;
  bottom: -5px;
  text-decoration: none;
  user-select: none;
}

.pkg-calendar-week,
.dates_container >>> .pkg-calendar-days {
  overflow: hidden;
  list-style: none;
  margin: 0;
  padding: 0;
}

.pkg-calendar-week > li {
  display: flex;
  align-content: center;
  justify-content: center;
  cursor: pointer;
}

.pkg-calendar-week > li,
.dates_container >>> .pkg-calendar-days > li {
  float: left;
  margin-right: 1%;
  margin-bottom: 6px;
  width: 13.4285%;
  font-size: 14px;
  text-align: center;
  padding: 15px 0;
  /* border-radius: 50%; */
  user-select: none;
}
.pkg-calendar-week > li:last-child,
.dates_container >>> .pkg-calendar-days > li:nth-of-type(7n) {
  margin-right: 0;
}

.pkg-calendar-week > li {
  text-transform: uppercase;
  font-weight: bold;
  color: #3c3c3c;
}

.pkg-calendar-week > li label {
  cursor: pointer;
}

.dates_container >>> .pkg-calendar-days > li {
  color: #3c3c3c;
  cursor: pointer;
}

.pkg-calendar-days li {
  width: 15px;
}

.dates_container >>> .pkg-calendar-days > li.disabled {
  background: #e5e5e5;
  pointer-events: none;
  color: #8f8f8f;
}
.dates_container >>> .pkg-calendar-days > li.active {
  background: #17a2b8;
  color: #fff;
}

.dates_container >>> .pkg-calendar-days > li.update {
  background: #17b82c;
  color: #fff;
}
.dates_container >>> .pkg-calendar-days > li.de_active {
  background: #929292;
  color: #fff;
}
.dates_container >>> .pkg-calendar-days > li.surcharge {
  background: #5457ad;
  color: #fff;
}
.dates_container >>> .pkg-calendar-days > li.update {
  background: #46a96d;
  color: #fff;
}

.form-group {
  margin: 0px;
}

.submit-btn {
  transition: 0.5s all ease-in-out;
}

.submit-btn >>> .spinner-border {
  width: 1rem;
  height: 1rem;
}

.search_package_btn {
  display: flex;
}

.search_package_btn input {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  margin: 0px;
}

.search_package_btn button {
  border-radius: 0px;
  border: 0px;
}

.dates_action_types label {
  cursor: pointer;
}

.action_buttons {
  display: flex;
  align-items: center;
  justify-content: center;
}

.action_buttons .action_btn_item {
  cursor: pointer;
  color: var(--gray);
  font-weight: 600;
  font-size: 12px;
}
.action_buttons .action_btn_item:not(:last-child) {
  margin-right: 15px;
}

.action_buttons .action_btn_item.active {
  color: var(--red-froly);
}
</style>
